import { TYPES } from "./types";
import { tkt1TrustedBankVisaService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getTKT1TrustedBankVisas = (query) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankVisaService.getTrustedBankVisas(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISAS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISAS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1TrustedBankVisaByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankVisaService.getTrustedBankVisaByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1TrustedBankVisaByVisaNumber = (visaNumber) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankVisaService.getTrustedBankVisaByVisaNumber(visaNumber);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_VISA_NUMBER_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_VISA_BY_VISA_NUMBER_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const searchTKT1TrustedBankVisas = (query) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankVisaService.searchTrustedBankVisas(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_TRUSTED_BANK_VISAS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_TRUSTED_BANK_VISAS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1TrustedBankVisa = (visaData) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankVisaService.createTrustedBankVisa(visaData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_TRUSTED_BANK_VISA_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_TRUSTED_BANK_VISA_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1TrustedBankVisa = (id, visaData) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankVisaService.updateTrustedBankVisa(id, visaData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_TRUSTED_BANK_VISA_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_TRUSTED_BANK_VISA_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1TrustedBankVisa = (id) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankVisaService.deleteTrustedBankVisa(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_TRUSTED_BANK_VISA_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_TRUSTED_BANK_VISA_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1TrustedBankVisaAction = {
  getTKT1TrustedBankVisas,
  getTKT1TrustedBankVisaByID,
  getTKT1TrustedBankVisaByVisaNumber,
  searchTKT1TrustedBankVisas,
  createTKT1TrustedBankVisa,
  updateTKT1TrustedBankVisa,
  deleteTKT1TrustedBankVisa
};
